import { uipApiInstance } from '../index';

export const ews = async (data: any, headers: any) => {
    try {
        const response = await uipApiInstance({
            method: 'POST',
            url: '/api/advice/ews',
            withCredentials: false,
            data,
            headers
        });
        return response.data;
    } catch (error) {
        console.error('Failed to call EWS:', error);
        return;
    }
};

export const runpipeProxy = async (data: any, headers: any) => {
    try {
        const response = await uipApiInstance({
            method: 'POST',
            url: '/api/advice/runpipe_proxy',
            withCredentials: false,
            data,
            headers
        });
        return response.data;
    } catch (error) {
        console.error('Failed to call runpipe_proxy:', error);
        return;
    }
};